import React, { useState } from 'react';
import { View, ScrollView } from 'react-native';
import { useForm } from 'react-hook-form';
import { Col, Grid, Row } from 'react-native-easy-grid';
import * as Yup from 'yup';
import { withNamespaces } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { LinearGradient } from 'expo-linear-gradient';
import { useHistory } from 'react-router-dom';

import HeaderToken from '@components/Headers/HeaderToken';
import styles from './style';
import JInput from '@components/common/JInput';
import ModalAlert from '@components/Modals/ModalAlert';
import { BTN_COLOR_PRIMARY } from '@assets/style/styleDefault';
import JButton from '@components/common/JButton';
import { JText as Text } from '@components/common/JText';

const SMSNotificationsTest = ({ t }) => {
  const history = useHistory();
  const [isModalSave, setIsModalSave] = useState(false);

  const schema = Yup.object().shape({
    destinationAddress: Yup.string().required(t('errorMessages.TXT_REQUIRED')),
    keySetting: Yup.string().required(t('errorMessages.TXT_REQUIRED')),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty, isValid },
  } = useForm({
    defaultValues: {
      destinationAddress: '',
      keySetting: '',
    },
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  const openModal = () => {
    setIsModalSave(!isModalSave);
  };

  const onSubmit = (data) => console.log(data);

  const openModalBack = () => {
    history.goBack();
  };

  const handleClick = () => {
    handleSubmit(onSubmit);
    reset();
    openModal();
  };

  return (
    <View style={styles.header}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={[styles.positionSticky]}>
          <HeaderToken
            linkBtnBack="iconX.svg"
            actionBtnBack={openModalBack}
            textBtnBack={t('commonText.cancelButton')}
            linkIcon="testSMS.svg"
            textHeader={t('pages_FileManager_SMSNotifications_SMSNotificationsTest.textHeader')}
            widthIconTitle={60}
            heightIconTitle={42}
            fullText
          />
        </View>
        <View style={styles.formSubmit}>
          <View style={styles.borderForm}>
            <Grid>
              <Row size={1}>
                <Col size={3} style={[styles.flexDirection, styles.titleInput]}>
                  <Text style={styles.textTitle}>
                    {t('pages_FileManager_SMSNotifications_SMSNotificationsTest.destinationAddress')}{' '}
                  </Text>
                  <Text style={styles.redColor}>✴︎</Text>
                </Col>
                <Col size={9}>
                  <View>
                    <JInput
                      placeholder={t(
                        'pages_FileManager_SMSNotifications_SMSNotificationsTest.destinationAddressPlaceholder'
                      )}
                      width="100%"
                      subfix="iconEdit.svg"
                      widthSubfix={18}
                      heightSubfix={18}
                      control={control}
                      name="destinationAddress"
                      paddingLeft={14}
                      borderError={errors.destinationAddress ? '#FF0000' : '#5C5C5C'}
                    />
                  </View>
                </Col>
              </Row>
              <Row size={9} style={styles.textArea}>
                <Col size={3} style={[styles.flexDirection, styles.titleInput]}>
                  <Text style={styles.textTitle}>
                    {t('pages_FileManager_SMSNotifications_SMSNotificationsTest.keySetting')}{' '}
                  </Text>
                  <Text style={styles.redColor}>✴︎</Text>
                </Col>
                <Col size={9}>
                  <View>
                    <JInput
                      placeholder={`${t(
                        'pages_FileManager_SMSNotifications_SMSNotificationsTest.keySettingPlaceholder'
                      )}`}
                      width="100%"
                      subfix="iconEdit.svg"
                      widthSubfix={18}
                      heightSubfix={18}
                      control={control}
                      name="keySetting"
                      paddingLeft={14}
                      multiline={true}
                      heightMulti={300}
                      borderError={errors.keySetting ? '#FF0000' : '#5C5C5C'}
                    />
                  </View>
                </Col>
              </Row>
              <Row size={4}>
                <Col size={3} style={[styles.flexDirection, styles.titleInput]}></Col>
                <Col size={9}>
                  <View style={styles.btnSubmit}>
                    <LinearGradient colors={['#32A5F7', '#2D81F3']} style={{ borderRadius: 5, width: 340 }}>
                      <JButton
                        text={t('pages_FileManager_SMSNotifications_SMSNotificationsTest.buttonTestSMS')}
                        width={340}
                        textColor="#f2f2f2"
                        btnColor={BTN_COLOR_PRIMARY}
                        hasIcon
                        linkIcon="submit.svg"
                        linkIconDisabled="sendGray.svg"
                        widthIcon={18}
                        heightIcon={18}
                        onPressAction={handleClick}
                        disabled={!isValid || !isDirty}
                      />
                    </LinearGradient>
                  </View>
                </Col>
              </Row>
            </Grid>
          </View>
        </View>
        <ModalAlert
          isModalVisible={isModalSave}
          setModalVisible={setIsModalSave}
          modalText="テストSMS送信しました"
          iconWidth={16}
          iconHeight={12.5}
          icon="successGreen.svg"
          linkPage="/file-manager/other-notifications"
        />
      </ScrollView>
    </View>
  );
};
export default withNamespaces()(SMSNotificationsTest);
